/* eslint-disable @typescript-eslint/camelcase */
import { handleActions } from 'redux-actions';
import { UserPartnersListProps, UsersState } from './interfaces';
import Types from './types';

const initialState: UsersState = {
  isLoading: false,
  allUsersList: { count: 0, next: '', previous: '', results: [] },
  isLoadingAllUsersList: false,
  usersForRecoveryList: { count: 0, next: '', previous: '', results: [] },
  isLoadingUsersForRecoveryList: false,
  recoveriesCountFromRequestUuid: 0,
  isLoadingRecoveriesCountFromRequestUuid: false,
  usersToManage: { count: 0, next: '', previous: '', results: [] },
  isLoadingUsersToManage: false,
  userPartnersList: {} as UserPartnersListProps,
  isLoadingUserPartnersList: false,
};

export default handleActions(
  {
    [Types.GET_ALL_USERS_REQUEST]: (state: UsersState): UsersState => ({
      ...state,
      isLoadingAllUsersList: true,
    }),
    [Types.GET_ALL_USERS_FULFILLED]: (
      state: UsersState,
      { payload }
    ): UsersState => ({
      ...state,
      allUsersList: payload,
      isLoadingAllUsersList: false,
    }),
    [Types.GET_ALL_USERS_REJECTED]: (state: UsersState): UsersState => ({
      ...state,
      isLoadingAllUsersList: false,
    }),

    [Types.GET_USERS_FOR_RECOVERY_REQUEST]: (
      state: UsersState
    ): UsersState => ({
      ...state,
      isLoadingUsersForRecoveryList: true,
    }),
    [Types.GET_USERS_FOR_RECOVERY_FULFILLED]: (
      state: UsersState,
      { payload }
    ): UsersState => ({
      ...state,
      usersForRecoveryList: payload,
      isLoadingUsersForRecoveryList: false,
    }),
    [Types.GET_USERS_FOR_RECOVERY_REJECTED]: (
      state: UsersState
    ): UsersState => ({
      ...state,
      isLoadingUsersForRecoveryList: false,
    }),

    [Types.GET_RECOVERIES_COUNT_FROM_REQUEST_UUID_REQUEST]: (
      state: UsersState
    ): UsersState => ({
      ...state,
      isLoadingRecoveriesCountFromRequestUuid: true,
    }),
    [Types.GET_RECOVERIES_COUNT_FROM_REQUEST_UUID_FULFILLED]: (
      state: UsersState,
      { payload }
    ): UsersState => ({
      ...state,
      recoveriesCountFromRequestUuid: payload,
      isLoadingRecoveriesCountFromRequestUuid: false,
    }),
    [Types.GET_RECOVERIES_COUNT_FROM_REQUEST_UUID_REJECTED]: (
      state: UsersState
    ): UsersState => ({
      ...state,
      isLoadingRecoveriesCountFromRequestUuid: false,
    }),

    [Types.RECOVER_USERS_BY_RECOVERY_UUIDS_REQUEST]: (
      state: UsersState
    ): UsersState => ({
      ...state,
      isLoadingUsersForRecoveryList: true,
    }),
    [Types.RECOVER_USERS_BY_RECOVERY_UUIDS_FULFILLED]: (
      state: UsersState
    ): UsersState => ({
      ...state,
      isLoadingUsersForRecoveryList: false,
    }),
    [Types.RECOVER_USERS_BY_RECOVERY_UUIDS_REJECTED]: (
      state: UsersState
    ): UsersState => ({
      ...state,
      isLoadingUsersForRecoveryList: false,
    }),

    [Types.RECOVER_USERS_BY_REQUEST_UUID_REQUEST]: (
      state: UsersState
    ): UsersState => ({
      ...state,
      isLoadingUsersForRecoveryList: true,
    }),
    [Types.RECOVER_USERS_BY_REQUEST_UUID_FULFILLED]: (
      state: UsersState
    ): UsersState => ({
      ...state,
      isLoadingUsersForRecoveryList: false,
    }),
    [Types.RECOVER_USERS_BY_REQUEST_UUID_REJECTED]: (
      state: UsersState
    ): UsersState => ({
      ...state,
      isLoadingUsersForRecoveryList: false,
    }),

    [Types.REMOVE_USERS_FROM_CLIENTS_REQUEST]: (
      state: UsersState
    ): UsersState => ({
      ...state,
      isLoadingUsersToManage: true,
    }),
    [Types.REMOVE_USERS_FROM_CLIENTS_FULFILLED]: (
      state: UsersState
    ): UsersState => ({
      ...state,
      isLoadingUsersToManage: false,
    }),
    [Types.REMOVE_USERS_FROM_CLIENTS_REJECTED]: (
      state: UsersState
    ): UsersState => ({
      ...state,
      isLoadingUsersToManage: false,
    }),

    [Types.GET_USERS_TO_MANAGE_REQUEST]: (state: UsersState): UsersState => ({
      ...state,
      isLoadingUsersToManage: true,
    }),
    [Types.GET_USERS_TO_MANAGE_FULFILLED]: (
      state: UsersState,
      { payload }
    ): UsersState => ({
      ...state,
      usersToManage: payload,
      isLoadingUsersToManage: false,
    }),
    [Types.GET_USERS_TO_MANAGE_REJECTED]: (state: UsersState): UsersState => ({
      ...state,
      isLoadingUsersToManage: false,
    }),

    [Types.REMOVE_USER_FROM_ALL_CLIENTS_REQUEST]: (
      state: UsersState
    ): UsersState => ({
      ...state,
      isLoading: true,
    }),
    [Types.REMOVE_USER_FROM_ALL_CLIENTS_FULFILLED]: (
      state: UsersState
    ): UsersState => ({
      ...state,
      isLoading: false,
    }),
    [Types.REMOVE_USER_FROM_ALL_CLIENTS_REJECTED]: (
      state: UsersState
    ): UsersState => ({
      ...state,
      isLoading: false,
    }),

    [Types.REMOVE_USER_PERMANENTLY_REQUEST]: (
      state: UsersState
    ): UsersState => ({
      ...state,
      isLoading: true,
    }),
    [Types.REMOVE_USER_PERMANENTLY_FULFILLED]: (
      state: UsersState
    ): UsersState => ({
      ...state,
      isLoading: false,
    }),
    [Types.REMOVE_USER_PERMANENTLY_REJECTED]: (
      state: UsersState
    ): UsersState => ({
      ...state,
      isLoading: false,
    }),

    [Types.REMOVE_MULTIPLE_USERS_PERMANENTLY_REQUEST]: (
      state: UsersState
    ): UsersState => ({
      ...state,
      isLoading: true,
    }),
    [Types.REMOVE_MULTIPLE_USERS_PERMANENTLY_FULFILLED]: (
      state: UsersState
    ): UsersState => ({
      ...state,
      isLoading: false,
    }),
    [Types.REMOVE_MULTIPLE_USERS_PERMANENTLY_REJECTED]: (
      state: UsersState
    ): UsersState => ({
      ...state,
      isLoading: false,
    }),

    [Types.GET_PARTNERS_BY_USER_UUID_REQUEST]: (
      state: UsersState
    ): UsersState => ({
      ...state,
      userPartnersList: { count: 0, next: '', previous: '', results: [] },
      isLoadingUserPartnersList: true,
    }),
    [Types.GET_PARTNERS_BY_USER_UUID_FULFILLED]: (
      state: UsersState,
      { payload }
    ): UsersState => ({
      ...state,
      userPartnersList: payload,
      isLoadingUserPartnersList: false,
    }),
    [Types.GET_PARTNERS_BY_USER_UUID_REJECTED]: (
      state: UsersState
    ): UsersState => ({
      ...state,
      isLoadingUserPartnersList: false,
    }),
  },
  initialState
);
